


var ws = {};

var wsurl = "ws://116.62.17.126:8007/ws/stream?topics=d3_digdev_data";

import { decode64 } from './base64'

// 连接服务端  
function connect3(val) {
    // 创建websocket
    // wsurl = val;
    ws = new WebSocket(wsurl);
    // 当socket连接打开时，输入用户名
    // ws.onopen = onopen;
    // 当有消息时根据消息类型显示不同信息
    ws.onmessage = onmessage;
    ws.onclose = function () {
        console.log("连接关闭，定时重连");
        connect3();
    };
    ws.onerror = function () {
        console.log("出现错误");
        connect3();
    };
    ws.onclose = onclose;
}

// 连接建立时发送登录信息
function onopen() {
    // ws.send('我来了');
}

function close3() {
    if(ws !== {}){
        ws.close();
    }
}

// 服务端发来消息时
function onmessage(e) {
    // console.log(JSON.parse(e.data), "dasda");
    // window.callpolicedata(JSON.parse(e.data))
    let ddd = decode64(JSON.parse(e.data).Body)
    window.jjjdata(JSON.parse(ddd));
    // console.log(ddd,"ddd");
}

//发送数据
function websocketsend(params) {
    ws.send(params);
}

export { connect3, websocketsend, close3 }